module.exports = __webpack_public_path__ + "static/fontaneria-ddfc40784b80cb0dabf62b1092ed3d18.jpg";